import { useState, useEffect, useMemo } from 'react';

/**
 * جلب كامل الصفوف للمبيانات (نفس منطق التصدير CSV).
 * يعتمد chartFiltersKey فقط لتقليل إعادة الجلب؛ applied/org يُقرآن من الإغلاق الحالي.
 */
export function useReportChartFetch(chartFiltersKey, fetchAllRows, applied, orgAppliedFilters) {
  const [chartRows, setChartRows] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setChartRows([]);
    (async () => {
      setChartLoading(true);
      try {
        const allRows = await fetchAllRows(applied, orgAppliedFilters);
        if (!cancelled) setChartRows(allRows);
      } catch {
        if (!cancelled) setChartRows([]);
      } finally {
        if (!cancelled) setChartLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- المفتاح يغطي applied/org؛ الدالة من الوحدة ثابتة
  }, [chartFiltersKey]);

  return { chartRows, chartLoading };
}

/**
 * جلب كامل الصفوف للمبيانات (نفس منطق التصدير CSV) عبر دالة بلا وسائط — مثل صفحات جلسات الطالب.
 */
export function useReportChartFetchByKey(chartFiltersKey, loadAllRows) {
  const [chartRows, setChartRows] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setChartRows([]);
    (async () => {
      setChartLoading(true);
      try {
        const allRows = await loadAllRows();
        if (!cancelled) setChartRows(Array.isArray(allRows) ? allRows : []);
      } catch {
        if (!cancelled) setChartRows([]);
      } finally {
        if (!cancelled) setChartLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- المفتاح يغطي المدخلات؛ الدالة من الإغلاق
  }, [chartFiltersKey]);

  return { chartRows, chartLoading };
}

export function useReportChartDisplay(chartRows, chartLoading, items, loading) {
  return useMemo(() => {
    /** صفوف الجدول الحالية كاحتياط حتى يكتمل جلب كامل الصفوف للمبيانات (لا نربطها بـ !loading لئلا تختفي المبيانات أثناء التحميل الأول). */
    const rowsForCharts =
      chartRows.length > 0 ? chartRows : items.length > 0 ? items : [];
    /** أثناء تحميل الجدول أو جلب دفعة المبيانات الكاملة ولا يوجد بعد أي صف للرسم — نعرض حالة التحميل لا «فارغ». */
    const chartsShowLoading =
      rowsForCharts.length === 0 && (loading || chartLoading);
    const partial =
      chartLoading && chartRows.length === 0 && items.length > 0 && !loading;
    return { rowsForCharts, chartsShowLoading, partial };
  }, [chartRows, chartLoading, items, loading]);
}
